import { InventoryTransferLine } from './inventory-transfer-line';
import { InventoryTransferStatus } from './enums';

export class StockTransferDetails {
    DocEntry: number;
    RequestNo: number;
    DocDate: Date;
    DueDate: Date;
    Comments: string;
    FromWarehouse: string;
    ToWarehouse: string;
    ItemsCount: number;
    Status: InventoryTransferStatus;
    StatusLabel?: string;
    Lines: InventoryTransferLine[] = [];
}
